import propType from 'prop-types';
import React from 'react';
import Arrow from '../../../../assets/svgs/arrow.svg';

const arrowDefaultProps = {
  className: '',
  style: {},
  onClick: () => undefined
};

const arrowPropTypes = {
  className: propType.string,
  style: propType.shape({}),
  onClick: propType.func
};
export function SlickArrowLeft(props) {
  const { className, style, onClick } = props;
  return (
    <div
      className={className}
      style={{ ...style, display: 'block' }}
      onClick={onClick}
    >
      <Arrow />
    </div>
  );
}

SlickArrowLeft.defaultProps = arrowDefaultProps;
SlickArrowLeft.propTypes = arrowPropTypes;

export function SlickArrowRight(props) {
  const { className, style, onClick } = props;
  return (
    <div
      className={className}
      style={{
        ...style,
        display: 'block',
        transform: 'rotate(180deg) translate(0, 50%)'
      }}
      onClick={onClick}
    >
      <Arrow />
    </div>
  );
}

SlickArrowRight.defaultProps = arrowDefaultProps;
SlickArrowRight.propTypes = arrowPropTypes;
